import axios from '../../functions/axios';
import { useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import  style from'./Car.module.css';

function AddCar() {
  const formReducer = (state, event) => {
    if (event.reset) {
      return {
        plate: '',
        name: '',
        brand: '',
      };
    }
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {});
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    await axios.post(`/car`, formData);
    navigate('/carsList');
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h2 className={style.category}>Dane samochodu</h2>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='plate-data'>
              Nr rejestracyjny:
            </label>
            <input
              type='text'
              id='plate-data'
              placeholder='podaj nr rejestracyjny'
              name='plate'
              onChange={handleChange}
              value={formData.plate?.toUpperCase() || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='brand-data'>
              Marka samochodu:
            </label>
            <input type='text' id='brand-data' placeholder='podaj marke samochodu' name='brand' onChange={handleChange} value={formData.brand || ''} />
          </div>
          <hr />
          <span className={style.buttons}>
            <button className='btn btn-default' onClick={navigate.bind(null, '/carsList', { state: { date: formData.day } })}>
              Anuluj
            </button>
            <button className='btn btn-default' type='submit'>
              Dodaj samochód
            </button>
          </span>
        </div>
      </form>
    </div>
  );
}

export default AddCar;